import { Hero } from "../components/Hero";
import { Marquee, Reveal } from "../components/Motion";
import { ProductSpotlight } from "../components/ProductSpotlight";
import { Bento } from "../components/Bento";
import { WaitlistForm } from "../components/WaitlistForm";
import { Footer } from "../components/Footer";
import { useProduct } from "../hooks/useProduct";
import { DropTeaser } from "../components/DropTeaser";
import { StayLit } from "../components/StayLit";
import { ContactSection } from "../components/Contact";

export default function Home() {
  const [product] = useProduct();
  return (
    <main data-testid="home-page">
      <Hero product={product} />
      <div className="bg-[#E10600] text-white py-6 border-y-4 border-[#0B0B0B]">
        <Marquee items={["Make parties great again", "Party Lyfe", "X-Squad", "#X", "#StayLitDieLit"]} />
      </div>
      <ProductSpotlight product={product} />
      <Bento />
      <StayLit />
      <section className="relative bg-[#E10600] text-white overflow-hidden grain" data-testid="home-teaser">
        <div className="relative z-10 px-5 sm:px-10 lg:px-16 py-24 md:py-32 grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-7">
          <Reveal>
            <p className="font-mono-x uppercase text-xs tracking-[0.25em] text-white font-bold">Next merch drop</p>
            <h2 className="font-display uppercase text-6xl sm:text-8xl lg:text-[8.5rem] leading-[0.85] mt-4">
              Something <br /><span className="text-stroke-white">is</span> <span className="text-[#0B0B0B]">coming.</span>
            </h2>
            <p className="mt-8 max-w-md text-lg font-bold">Be first in line when Drop 002 hits. No spam — just the drop.</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10"><WaitlistForm /></Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-5 w-full max-w-md mx-auto"><DropTeaser /></Reveal>
        </div>
      </section>
      <ContactSection />
      <Footer />
    </main>
  );
}
